// Subset/interdataset filters are nested under a `${datasetId}>` key:
// { field: { matchMode: value } }
export const isSubsetGroup = (key: string, entry: Record<string, any>) =>
  key.endsWith('>') &&
  Object.values(entry).every((v) => v !== null && typeof v === 'object');
